import { ConnectedRouter as WrongConnectedRouter } from "connected-react-router";
import "core-js";
import { createBrowserHistory } from "history";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { Provider as WrongProvider } from "react-redux";
import App from "./App";
import { unregister as unregisterServiceWorker } from "./registerServiceWorker";
import configureStore from "./store/configureStore";
import { Service } from "./services/Service";
import { actionCreators as CurrentUserActionCreators } from "./store/CurrentUser";
import { IUser } from "./resources/Contracts";

const Provider = WrongProvider as any;
const ConnectedRouter = WrongConnectedRouter as any;

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href") as string;
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore(history);

const startApp = async (): Promise<void> => {
	let user: IUser;

	async function loadUser() {
		try {
			user = await Service.getCurrentUser();
		} catch (error) {
			console.error(error);
		}

		if (user) {
			store.dispatch(CurrentUserActionCreators.setCurrentUserName(user));

			const timeoutMinutes: number = 20;
			const timeoutSeconds: number = 10;

			const totalTimeoutMs: number = timeoutMinutes * 60 * 1000 + timeoutSeconds * 1000;

			setTimeout(() => {
				loadUser();
			}, totalTimeoutMs);
		}
	}

	await loadUser();

	ReactDOM.render(
		<Provider store={store}>
			<ConnectedRouter history={history}>
				<App />
			</ConnectedRouter>
		</Provider>,
		document.getElementById("root")
	);
};

startApp();

//registerServiceWorker();
unregisterServiceWorker();
